var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a;
import { registerDashboard } from '../../registryCore';
import { createCartesianWidget } from '../cartesian/cartesianChart';
var CARTESIAN_TYPES = [
    { type: 'lineChart', variant: 'line' },
    { type: 'areaChart', variant: 'area' },
    { type: 'barChart', variant: 'bar' },
    { type: 'columnChart', variant: 'bar' },
    { type: 'horizontalBarChart', variant: 'horizontalBar' },
    { type: 'stackedColumnChart', variant: 'stackedColumn' },
    { type: 'stackedBarChart', variant: 'stackedBar' },
    { type: 'stackedAreaChart', variant: 'stackedArea' },
    { type: 'stepChart', variant: 'step' },
    { type: 'splineChart', variant: 'spline' },
    { type: 'errorBarChart', variant: 'errorBar' },
    { type: 'lollipopChart', variant: 'lollipop' },
    { type: 'dotPlot', variant: 'dotPlot' },
    { type: 'stripPlot', variant: 'stripPlot' },
    { type: 'sparklineChart', variant: 'sparkline' },
    { type: 'rangeChart', variant: 'range' },
    { type: 'rangeAreaChart', variant: 'rangeArea' },
    { type: 'bandChart', variant: 'band' },
    { type: 'ribbonChart', variant: 'ribbon' },
    { type: 'combinationChart', variant: 'combination' },
    { type: 'mixedChart', variant: 'mixed' },
    { type: 'waterfallChart', variant: 'waterfall' },
    { type: 'paretoChart', variant: 'pareto' },
    { type: 'runChart', variant: 'run' },
    { type: 'controlChart', variant: 'control' },
    { type: 'populationPyramidChart', variant: 'populationPyramid' },
    { type: 'bumpChart', variant: 'bump' },
    { type: 'horizonChart', variant: 'horizon' },
];
var _loop_1 = function (type, variant) {
    registerDashboard(type, function (props, app) { return createCartesianWidget(app, type, props, variant); });
};
try {
    for (var CARTESIAN_TYPES_1 = __values(CARTESIAN_TYPES), CARTESIAN_TYPES_1_1 = CARTESIAN_TYPES_1.next(); !CARTESIAN_TYPES_1_1.done; CARTESIAN_TYPES_1_1 = CARTESIAN_TYPES_1.next()) {
        var _b = CARTESIAN_TYPES_1_1.value, type = _b.type, variant = _b.variant;
        _loop_1(type, variant);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (CARTESIAN_TYPES_1_1 && !CARTESIAN_TYPES_1_1.done && (_a = CARTESIAN_TYPES_1.return)) _a.call(CARTESIAN_TYPES_1);
    }
    finally { if (e_1) throw e_1.error; }
}
